// extracted by mini-css-extract-plugin
module.exports =  {"container":"T5MmWat8xxGCf8Iygfja"};